import { useGridRootProps } from "@components/DataGrid/hooks/useGridRootProps";
import i18n from "@i18n/i18n";
import BarChartIcon from "@mui/icons-material/BarChart";
import { Button, ButtonProps, Tooltip, TooltipProps } from "@mui/material";
import { unstable_useId as useId } from "@mui/material/utils";
import PropTypes from "prop-types";
import { forwardRef } from "react";

export interface GridToolbarCompareButtonProps {
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps?: { button?: Partial<ButtonProps>; tooltip?: Partial<TooltipProps> };
}

const GridToolbarCompareButton = forwardRef<HTMLButtonElement, GridToolbarCompareButtonProps>(function GridToolbarCompareButton(props, ref) {
  const { slotProps = {} } = props;
  const buttonProps = slotProps.button || {};
  const tooltipProps = slotProps.tooltip || {};
  const compareButtonId = useId();
  const rootProps = useGridRootProps();

  const showCompare = (event: any) => {
    buttonProps.onClick?.(event);
  };

  //console.log("rootProps: ", rootProps);
  //console.log("slotProps: ", slotProps);

  return (
    <Tooltip title={i18n.t("grid-toolbar-compare-button.title")} enterDelay={1000} {...tooltipProps} {...rootProps.slotProps?.baseTooltip}>
      <Button
        ref={ref}
        id={compareButtonId}
        size="small"
        aria-label={i18n.t("grid-toolbar-compare-button.title")}
        //aria-haspopup="menu"
        //aria-expanded={isOpen}
        //aria-controls={isOpen ? comparePanelId : undefined}
        startIcon={<BarChartIcon />}
        {...buttonProps}
        onClick={showCompare}
        component="span"
        {...rootProps.slotProps?.baseButton}
      >
        {i18n.t("grid-toolbar-compare-button.title")}
      </Button>
    </Tooltip>
  );

  /*
  return (
    <rootProps.slots.baseTooltip title={i18n.t("grid-toolbar-import-button.title")} enterDelay={1000} {...tooltipProps} {...rootProps.slotProps?.baseTooltip}>
        <rootProps.slots.baseLoadingButton
          ref={ref}
          id={importButtonId}
          size="small"
          aria-label={i18n.t("grid-toolbar-import-button.title")}
          aria-haspopup="menu"
          aria-expanded={isOpen}
          aria-controls={isOpen ? importPanelId : undefined}
          startIcon={<FileUploadIcon />}
          {...loadingButtonProps}
          onClick={showImport}
          loading={isLoading}
          loadingPosition={loadingButtonProps.loadingPosition || "start"}
          {...rootProps.slotProps?.baseLoadingButton}
        >
          {i18n.t("grid-toolbar-import-button.title")}
        </rootProps.slots.baseLoadingButton>
    </rootProps.slots.baseTooltip>
  );
  */
});

GridToolbarCompareButton.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: PropTypes.object,
} as any;

export { GridToolbarCompareButton };

